<template>
  <router-link :to="{ name: linkName }" class="t-link-back">
    <svg class="t-link-back__svg" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M3 12H21M7 16L3 12L7 16ZM3 12L7 8L3 12Z"
        stroke="#00b0bd"
        stroke-width="1.7"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
    <span>{{ btn }}</span>
  </router-link>
</template>

<script>
export default {
  name: 'link-back',
  props: ['btn', 'linkName'],
}
</script>

<style lang="sass"></style>



// WEBPACK FOOTER //
// src/templates/components/lk/link-back/link-back.vue